import type { ComponentType } from 'react';

import {
	ArgoCDProjectIcon,
	ArgoCDApplicationIcon,
	ArgoCDApplicationSetIcon,
	type IconProps
} from '../DaasContentCard';
import {
  DAAS_APPLICATION_SET_TYPE,
  DAAS_APPLICATION_TYPE,
  DAAS_PROJECT_TYPE,
  type DaaSType,
} from '../../types';

export const DAAS_TYPE_TABS: {
  label: string;
  type: DaaSType;
  createButtonLabel: string;
  Icon: ComponentType<IconProps>;
}[] = [
  {
    label: 'Projects',
    type: DAAS_PROJECT_TYPE,
    createButtonLabel: 'Create Project',
    Icon: ArgoCDProjectIcon,
  },
  {
    label: 'Applications',
    type: DAAS_APPLICATION_TYPE,
    createButtonLabel: 'Create Application',
    Icon: ArgoCDApplicationIcon,
  },
  {
    label: 'Application Sets',
    type: DAAS_APPLICATION_SET_TYPE,
    createButtonLabel: 'Create Application Set',
    Icon: ArgoCDApplicationSetIcon,
  },
];
